import { Component } from 'react';
import ErrorPage from '../pages/ErrorPage';
import { defaultLanguage } from '../config/languages';

// Catches render-time errors anywhere below it and shows the 500 page instead
// of a blank screen. Must be a class component — React has no hook equivalent
// for error boundaries.
export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surfaced for debugging / future error reporting.
    console.error('Unhandled UI error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          code={500}
          langCode={this.props.langCode || defaultLanguage}
          onRetry={() => window.location.reload()}
        />
      );
    }
    return this.props.children;
  }
}
